const FilterType = Object.freeze({
  BRAND: 'BRAND',
  OPTION: 'OPTION',
  DIETARY: 'DIETARY',
  CUSTOM_BRANDS: 'CUSTOM_BRANDS',
  CUSTOM_OPTION: 'CUSTOM_OPTION',
  CUSTOM_DIETARY: 'CUSTOM_DIETARY',
  CUSTOM: 'CUSTOM',
  PRICE: 'PRICE',
});
export default FilterType;

export const FILTER_TYPE_TO_NAME_MAPPING = {
  [FilterType.BRAND]: 'Brands',
  [FilterType.OPTION]: 'Options',
  [FilterType.DIETARY]: 'Dietary & Lifestyle',
  [FilterType.CUSTOM_BRANDS]: 'Brands',
  [FilterType.CUSTOM_OPTION]: 'Options',
  [FilterType.CUSTOM_DIETARY]: 'Dietary & Lifestyle',
  [FilterType.PRICE]: 'Price',
};
